/**
 * Moves the account's unit (`GET /auth/me`'s `weightUnit`, `D266`) into the
 * device's synchronous copy (`stores/weight-unit.ts`) whenever `me` is read.
 *
 * Mounted once, inside the session gate (`app/shell.tsx`), beside
 * `ClockBridge`. `null` on the server is "never chose" and changes nothing
 * here, so a device that has a choice the server has not heard yet (an
 * outbox write still pending) keeps it — and the outbox's optimistic overlay
 * already shows that pending choice on `me` anyway.
 */
import { meOptions } from "@repo/client/data/me";
import { useQuery } from "@tanstack/react-query";
import { type ReactNode, useEffect } from "react";
import { useApi } from "../../data/api";
import { setWeightUnit } from "../../stores/weight-unit";

export function WeightUnitBridge(): ReactNode {
  const api = useApi();
  const stored = useQuery(meOptions(api)).data?.weightUnit ?? null;
  useEffect(() => {
    if (stored !== null) {
      setWeightUnit(stored);
    }
  }, [stored]);
  return null;
}
